/** Music frame chrome. */
export default {
  findingTrack: "Finding the right track…",
  noTrack: "No track selected",
  spotifyPlayer: "Spotify player",
} as const;
